var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 15 19" }, props),
    React.createElement("path", { d: "M11.259 12L7.943 8.684a.949.949 0 0 1 0-1.339.944.944 0 0 1 1.34 0l4.914 4.914a.945.945 0 0 1 .273.739.945.945 0 0 1-.273.739l-4.914 4.914a.944.944 0 0 1-1.34 0 .949.949 0 0 1 0-1.34L11.254 14H5a5 5 0 0 1-5-5V1a1 1 0 0 1 2 0v8a3 3 0 0 0 3 3h6.259z", fill: "currentColor" })
  );
});